import { SUPPLIER_INSTALLATION_EMISSION_REPORT_EXCLUDED_CN_CODE } from './constants'

export { SUPPLIER_INSTALLATION_EMISSION_REPORT_EXCLUDED_CN_CODE }

export function normalizeSupplierInstallationEmissionReportCnCode(
  cnCode: string
): string {
  return cnCode.trim()
}
